import type { ScaleBand } from 'd3-scale';
import type { SegmentedChoicesData } from '../../types';
import {
  MIN_BAR_HEIGHT,
  SMALL_BAR_RADIUS,
  VALUE_TEXT_HEIGHT,
  VALUE_TEXT_MARGIN,
} from '../constants';
import { Score, type CorrectnessIndicatorStatus } from '../Score';

interface EmptyBarsProps {
  data: SegmentedChoicesData[];
  discreteScale: ScaleBand<string>;
  boundedHeight: number;
  textColor: string;
  placeHolderColor: string;
  shouldShowPercent: false | { percentOf: number };
  disableAnimations: boolean;
  getCorrectnessIndicatorStatus: (barId: number) => CorrectnessIndicatorStatus;
}
export const EmptyBars = ({
  data,
  discreteScale,
  boundedHeight,
  textColor,
  placeHolderColor,
  shouldShowPercent,
  disableAnimations,
  getCorrectnessIndicatorStatus,
}: EmptyBarsProps) => {
  return data.map((d) => {
    const x = discreteScale(String(d.id)) || 0;
    const rectangleY = boundedHeight - MIN_BAR_HEIGHT;

    const isEmptyBar = d.scores.every((score) => score === 0);
    if (!isEmptyBar) {
      return null;
    }

    return (
      <g key={d.id} data-name={`empty-bar-segment-${d.id}`}>
        <Score
          x={x}
          y={rectangleY - VALUE_TEXT_MARGIN}
          barWidth={discreteScale.bandwidth()}
          textColor={textColor}
          height={VALUE_TEXT_HEIGHT}
          scoreDisplayText={shouldShowPercent ? '0' : '0%'}
          correctnessIndicatorStatus={getCorrectnessIndicatorStatus(d.id)}
          disableAnimations={disableAnimations}
        />
        <rect
          x={x}
          y={rectangleY}
          height={MIN_BAR_HEIGHT}
          width={discreteScale.bandwidth()}
          rx={SMALL_BAR_RADIUS}
          ry={SMALL_BAR_RADIUS}
          fill={placeHolderColor}
          opacity={1}
        />
      </g>
    );
  });
};
